import { render } from "./ManageAdvert.vue?vue&type=template&id=283e87e6&scoped=true"
import script from "./ManageAdvert.vue?vue&type=script&lang=js"
export * from "./ManageAdvert.vue?vue&type=script&lang=js"

import "./ManageAdvert.vue?vue&type=style&index=0&id=283e87e6&lang=postcss&scoped=true"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283e87e6"]])

export default __exports__